// extracted by mini-css-extract-plugin
export default {"tooltip":"TooltipMobile_tooltip__kQgRZ"};